import { render, staticRenderFns } from "./UnitInputGroupUnequalAllocation.vue?vue&type=template&id=55cbbbc4&scoped=true"
import script from "./UnitInputGroupUnequalAllocation.vue?vue&type=script&lang=js"
export * from "./UnitInputGroupUnequalAllocation.vue?vue&type=script&lang=js"
import style0 from "./UnitInputGroupUnequalAllocation.vue?vue&type=style&index=0&id=55cbbbc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbbbc4",
  null
  
)

export default component.exports